import { makeStyles } from '@material-ui/styles';
import { useMessageContext, MessageText } from 'stream-chat-react';
import cl from 'clsx';

import MessageContentWrapper from '../MessageContentWrapper';
import MessageContentHeader from '../MessageContentHeader';
import MessageRetry from '../MessageRetry';

const CustomMessage: React.FC = () => {
    const { message } = useMessageContext();
    const classes = useStyles();

    const messageFailed = message.status === 'failed';

    return (
        <MessageContentWrapper>
            <MessageContentHeader messageRetry={<MessageRetry />} />
            <MessageText
                customInnerClass={cl(classes.text, {
                    [classes.failedMessageText]: messageFailed,
                })}
            />
        </MessageContentWrapper>
    );
};

const useStyles = makeStyles(
    theme => ({
        text: {
            ...theme.typography.t71,
            wordBreak: 'break-word',
            color: theme.palette.greys[600],
            marginTop: 10,
            whiteSpace: 'pre-line',
            '& p': {
                margin: 0,
            },
            '& .str-chat__message-url-link': {
                color: theme.palette.greys[600],
                whiteSpace: 'normal',
            },
        },
        failedMessageText: {
            color: theme.palette.greys[400],
            '& div[class^=str-chat][class$=-message--error-message]': {
                display: 'none',
            },
        },
    }),
    { classNamePrefix: 'custom-message' }
);

export default CustomMessage;
